import React, { FunctionComponent } from "react";
import { useIntl } from "react-intl";

import { Box } from "@chakra-ui/react";
import { MdCloudOff } from "react-icons/md";

import { useGlobalState } from "common/global-state";


interface IProps {}


const ConnectionStatus: FunctionComponent<IProps> = () => {
  const intl = useIntl();
  const { connected } = useGlobalState();

  return (
    connected ? (<Box/>) : (
      <Box
        px={2}
        title={intl.formatMessage({
          id: "site__disconnected",
          defaultMessage: "Connection to live data not established",
        })}
      >
        <MdCloudOff size="20" />
      </Box>
    )
  );
};

export default ConnectionStatus;
